import { render, staticRenderFns } from "./xiaohei_order_check_audit.vue?vue&type=template&id=7c71e46e&scoped=true"
import script from "./xiaohei_order_check_audit.vue?vue&type=script&lang=js"
export * from "./xiaohei_order_check_audit.vue?vue&type=script&lang=js"
import style0 from "./xiaohei_order_check_audit.vue?vue&type=style&index=0&id=7c71e46e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71e46e",
  null
  
)

export default component.exports